<template>
  <div>
    <h5 class="data-cell" v-html="$bc.distanceFormat(distance,'major')" />
    <h5 class="data-cell" v-html="$bc.elevationFormat(elevation)" />
    <h5 class="data-cell" v-html="$bc.timeFormat(elapsedTime)" />
  </div>
</template>

<script>
import linq from '../../../library/linq'
export default {
  name: 'activity-collection-cell',
  props: {
    activities: {
      type: Array,
      required: true,
    },
  },
  computed: {
      distance() {
          return  linq.sum(this.activities, (a) => a.distance);
      },
      elevation() {
          return  linq.sum(this.activities, (a) => a.total_elevation_gain);
      },
      elapsedTime() {
          return  linq.sum(this.activities, (a) => a.elapsed_time);
      }
  }
}
</script>

<style>
</style>